"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const AppLoader = ({
  color,
  ...restProps
}) => {
  const accessibilityProps = {
    'aria-live': restProps['aria-live'] || 'polite',
    'aria-label': restProps['aria-label'] || 'Laster innhold'
  };
  return (0, _jsxRuntime.jsxs)("div", {
    role: "status",
    css: theme => [_styles.styles.default(theme, color)],
    ...restProps,
    ...accessibilityProps,
    children: [(0, _jsxRuntime.jsx)("div", {}), (0, _jsxRuntime.jsx)("div", {}), (0, _jsxRuntime.jsx)("div", {}), (0, _jsxRuntime.jsx)("div", {})]
  });
};
var _default = exports.default = AppLoader;